export function randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function validateEmail(email) {
    /* eslint-disable */
    return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(email);
}

export function validatePhone(phone) {
    let phoneCheck = phone.replace(/ /g, '');
    if (phoneCheck.length < 10) return false;

    phoneCheck = phoneCheck.replace('+', '');

    return /^\d+$/.test(phoneCheck) && phoneCheck.length === 10;
}

export class Stopwatch {
    #startTime;

    constructor() {
        this.#startTime = performance.now();
    }

    Result() {
        return 'Time elapsed: ' + this.milliseconds + ' ms';
    }

    get milliseconds() {
        return performance.now() - this.#startTime;
    }
}
